module.exports = __webpack_public_path__ + "img/SprainedWristThumb.d330d26e.svg";